// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit log table — aligned to Haven brand tokens. Mirrors the
   document-manager table treatment (light header row, subtle hover,
   soft borders using surface tokens). */
.audit-table-wrapper {
  background: transparent;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
}

.audit-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.audit-table thead {
  background: var(--color-surface-light);
}

.audit-table th {
  text-align: left;
  padding: 8px 12px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  font-weight: 500;
  border-bottom: 2px solid var(--color-surface-dark);
}

.audit-table td {
  padding: 10px 12px;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-dark);
  vertical-align: middle;
}

.audit-table tr:last-child td {
  border-bottom: none;
}

.audit-table tbody tr:hover {
  background: var(--color-surface-light);
}

.audit-table-time {
  color: var(--color-text-secondary);
  white-space: nowrap;
  font-size: 13px;
}

.audit-table-action {
  display: inline-block;
  padding: 2px 8px;
  background: rgba(76, 106, 88, 0.12);
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-secondary);
  font-family: var(--font-family-mono);
}

.audit-table-resource {
  color: var(--color-text-secondary);
  font-family: var(--font-family-mono);
  font-size: 12px;
}

.audit-table-detail {
  color: var(--color-text-primary);
  font-family: var(--font-family-mono);
  font-size: 12px;
  max-width: 480px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audit-table-status {
  padding: 32px;
  text-align: center;
  color: var(--color-text-secondary);
  background: var(--color-surface-light);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-size: 14px;
}

.audit-table-empty {
  font-style: italic;
}

.audit-table-load-more {
  display: flex;
  justify-content: center;
  padding: 16px;
  background: var(--color-surface-light);
  border-top: 1px solid var(--color-surface-dark);
}

.audit-table-load-more-btn {
  padding: 6px 16px;
  background: transparent;
  color: var(--color-secondary);
  border: 1px solid var(--color-secondary);
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s;
}

.audit-table-load-more-btn:hover:not(:disabled) {
  background: rgba(76, 106, 88, 0.08);
}

.audit-table-load-more-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.audit-table-end {
  font-size: 13px;
  color: var(--color-text-secondary);
  font-style: italic;
}

/* -----------------------------------------------------------------
   Mobile: card-per-row layout below 640px.

   The audit table has 5-6 columns (Time, User, Org?, Action, Resource,
   Details) — on a phone that either scrolls horizontally or crams text
   into unreadable slivers. Below 640px we collapse table primitives to
   block boxes so each row becomes a stacked card. Desktop untouched.
   ----------------------------------------------------------------- */
@media (max-width: 640px) {
  .audit-table-wrapper {
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;
  }

  .audit-table,
  .audit-table thead,
  .audit-table tbody,
  .audit-table tr,
  .audit-table th,
  .audit-table td {
    display: block;
    width: 100%;
  }

  /* Hide the column header row entirely — irrelevant when rows are cards. */
  .audit-table thead {
    position: absolute;
    left: -9999px;
  }

  .audit-table tr {
    border: 1px solid var(--color-border);
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    background: var(--color-surface-light);
  }

  .audit-table td {
    padding: 3px 0;
    border-bottom: none;
    vertical-align: baseline;
  }

  /* Time is the header of the card. */
  .audit-table-time {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-text-secondary);
    margin-bottom: 4px;
  }

  /* Action badge stays inline / prominent. */
  .audit-table-action {
    font-size: 13px;
  }

  /* Details can be long paths — allow wrapping instead of ellipsis so
     the whole value is visible on the card. */
  .audit-table-detail {
    max-width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: break-word;
    padding-top: 4px;
    color: var(--color-text-secondary);
  }

  .audit-table-resource {
    font-size: 11px;
  }

  /* Cells become part of a card body — collapse empty cells. */
  .audit-table td:empty {
    display: none;
  }
}

/* Defensive mobile hardening — audit-table-wrapper had been sending
   entries past the viewport because the border+background/padding was
   applied without box-sizing, and long detail strings in the table
   below 640px could still push beyond the wrapper. */
@media (max-width: 767px) {
  .audit-table-wrapper {
    max-width: 100%;
    box-sizing: border-box;
  }

  .audit-table,
  .audit-table tr,
  .audit-table td {
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Any code / action badges inside a card should wrap rather than
     force horizontal overflow. */
  .audit-table-action,
  .audit-table-resource {
    max-width: 100%;
    word-break: break-word;
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./../shared/audit/AuditLogTable.css"],"names":[],"mappings":"AAAA;;wCAEwC;AACxC;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;;;;;;sEAOsE;AACtE;EACE;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;;;IAME,cAAc;IACd,WAAW;EACb;;EAEA,0EAA0E;EAC1E;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA,2CAA2C;EAC3C;IACE,eAAe;EACjB;;EAEA;8CAC4C;EAC5C;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;AACF;;AAEA;;;qDAGqD;AACrD;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;;;IAGE,eAAe;IACf,sBAAsB;EACxB;;EAEA;iCAC+B;EAC/B;;IAEE,eAAe;IACf,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* Audit log table — aligned to Haven brand tokens. Mirrors the\n   document-manager table treatment (light header row, subtle hover,\n   soft borders using surface tokens). */\n.audit-table-wrapper {\n  background: transparent;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.audit-table thead {\n  background: var(--color-surface-light);\n}\n\n.audit-table th {\n  text-align: left;\n  padding: 8px 12px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  border-bottom: 2px solid var(--color-surface-dark);\n}\n\n.audit-table td {\n  padding: 10px 12px;\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-surface-dark);\n  vertical-align: middle;\n}\n\n.audit-table tr:last-child td {\n  border-bottom: none;\n}\n\n.audit-table tbody tr:hover {\n  background: var(--color-surface-light);\n}\n\n.audit-table-time {\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.audit-table-action {\n  display: inline-block;\n  padding: 2px 8px;\n  background: rgba(76, 106, 88, 0.12);\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-secondary);\n  font-family: var(--font-family-mono);\n}\n\n.audit-table-resource {\n  color: var(--color-text-secondary);\n  font-family: var(--font-family-mono);\n  font-size: 12px;\n}\n\n.audit-table-detail {\n  color: var(--color-text-primary);\n  font-family: var(--font-family-mono);\n  font-size: 12px;\n  max-width: 480px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.audit-table-status {\n  padding: 32px;\n  text-align: center;\n  color: var(--color-text-secondary);\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.audit-table-empty {\n  font-style: italic;\n}\n\n.audit-table-load-more {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  background: var(--color-surface-light);\n  border-top: 1px solid var(--color-surface-dark);\n}\n\n.audit-table-load-more-btn {\n  padding: 6px 16px;\n  background: transparent;\n  color: var(--color-secondary);\n  border: 1px solid var(--color-secondary);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.15s;\n}\n\n.audit-table-load-more-btn:hover:not(:disabled) {\n  background: rgba(76, 106, 88, 0.08);\n}\n\n.audit-table-load-more-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.audit-table-end {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n/* -----------------------------------------------------------------\n   Mobile: card-per-row layout below 640px.\n\n   The audit table has 5-6 columns (Time, User, Org?, Action, Resource,\n   Details) — on a phone that either scrolls horizontally or crams text\n   into unreadable slivers. Below 640px we collapse table primitives to\n   block boxes so each row becomes a stacked card. Desktop untouched.\n   ----------------------------------------------------------------- */\n@media (max-width: 640px) {\n  .audit-table-wrapper {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    overflow: visible;\n  }\n\n  .audit-table,\n  .audit-table thead,\n  .audit-table tbody,\n  .audit-table tr,\n  .audit-table th,\n  .audit-table td {\n    display: block;\n    width: 100%;\n  }\n\n  /* Hide the column header row entirely — irrelevant when rows are cards. */\n  .audit-table thead {\n    position: absolute;\n    left: -9999px;\n  }\n\n  .audit-table tr {\n    border: 1px solid var(--color-border);\n    border-radius: 8px;\n    padding: 12px;\n    margin-bottom: 10px;\n    background: var(--color-surface-light);\n  }\n\n  .audit-table td {\n    padding: 3px 0;\n    border-bottom: none;\n    vertical-align: baseline;\n  }\n\n  /* Time is the header of the card. */\n  .audit-table-time {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--color-text-secondary);\n    margin-bottom: 4px;\n  }\n\n  /* Action badge stays inline / prominent. */\n  .audit-table-action {\n    font-size: 13px;\n  }\n\n  /* Details can be long paths — allow wrapping instead of ellipsis so\n     the whole value is visible on the card. */\n  .audit-table-detail {\n    max-width: 100%;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    word-break: break-word;\n    padding-top: 4px;\n    color: var(--color-text-secondary);\n  }\n\n  .audit-table-resource {\n    font-size: 11px;\n  }\n\n  /* Cells become part of a card body — collapse empty cells. */\n  .audit-table td:empty {\n    display: none;\n  }\n}\n\n/* Defensive mobile hardening — audit-table-wrapper had been sending\n   entries past the viewport because the border+background/padding was\n   applied without box-sizing, and long detail strings in the table\n   below 640px could still push beyond the wrapper. */\n@media (max-width: 767px) {\n  .audit-table-wrapper {\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  .audit-table,\n  .audit-table tr,\n  .audit-table td {\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  /* Any code / action badges inside a card should wrap rather than\n     force horizontal overflow. */\n  .audit-table-action,\n  .audit-table-resource {\n    max-width: 100%;\n    word-break: break-word;\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
